import React, { useState } from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import * as Icons from "react-feather";
import { FeatherIcon } from "component/shared/feather-icon";
import { NewMarketResource } from "api/resource/market";
import { CriterionCard } from "../criterion-card";
import { InfoCard } from "../info-card";
import { styles } from "./style";
import { AppCard } from "component/shared/app-card";

interface MarketCardProps extends WithStyles<typeof styles> {
	market: NewMarketResource;
	index: number;
}

const Component: React.FC<MarketCardProps> = ({ classes = {}, market, index }) => {
	const theme = Mui.useTheme();
	const [expanded, setExpanded] = useState(false);

	return (
		<AppCard className={classes.card}>
			<Mui.CardHeader
				avatar={
					<Mui.Avatar className={classes.avatar}>
						{index + 1}
					</Mui.Avatar>
				}
				title={market.name}
				// subheader={market.description}
				action={
					<Mui.Box display="flex" alignItems="center" className={classes.actionContainer}>
						<Mui.IconButton
							onClick={() => setExpanded(!expanded)}
							aria-expanded={expanded}
							aria-label="show more"
						>
							<FeatherIcon>
								{expanded ? <Icons.ChevronUp /> : <Icons.ChevronDown />}
							</FeatherIcon>
						</Mui.IconButton>
					</Mui.Box>
				}
			/>
			
			<Mui.Collapse in={expanded} timeout="auto" unmountOnExit>
				<Mui.CardContent>
					{/* Basic Information */}
					<Mui.Box className={classes.infoSection}>
						<Mui.Typography variant="subtitle2" gutterBottom className={classes.sectionTitle}>
							Basic Information
						</Mui.Typography>
						<Mui.Grid container spacing={1}>
							<Mui.Grid item xs={12} sm={6} md={4}>
								<InfoCard 
									label="Sort Order" 
									value={market.sortOrder || 'N/A'} 
									fieldName="sortOrder"
								/>
							</Mui.Grid>
							<Mui.Grid item xs={12} sm={6} md={4}>
								<InfoCard 
									label="Inactive" 
									value={market.inactive} 
									fieldName="inactive"
								/>
							</Mui.Grid>
							<Mui.Grid item xs={12} sm={6} md={4}>
								<InfoCard 
									label="Show on Index" 
									value={market.showOnIndex || false} 
									fieldName="showOnIndex"
								/>
							</Mui.Grid>
						</Mui.Grid>
					</Mui.Box>

					{/* Search Criteria */}
					{market.criteria && market.criteria.length > 0 && (
						<Mui.Box>
							<Mui.Typography variant="subtitle2" gutterBottom className={classes.sectionTitle}>
								Search Criteria ({market.criteria.length})
							</Mui.Typography>
							<Mui.Grid container spacing={1}>
								{market.criteria.map((criterion, criterionIndex) => (
									<Mui.Grid item xs={12} sm={6} md={3} key={criterionIndex}>
										<CriterionCard criterion={criterion} />
									</Mui.Grid>
								))}
							</Mui.Grid>
						</Mui.Box>
					)}
				</Mui.CardContent>
			</Mui.Collapse>
		</AppCard>
	);
};

export const MarketCard = withStyles(Component, styles);